<template>
    <div id="app" class="h-100" :class="isTouchDevice ? 'touch' : 'no-touch'">
        <transition name="fade">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    export default {
        computed: {
            isTouchDevice: function () {
                if (('ontouchstart' in window) || window.DocumentTouch) {
                    return true
                }

                return false
            }
        },
        created () {
            this.$root.query = {};
            this.$root.query.cards = !!this.$route.query.cards;
            this.$root.query.video = !!this.$route.query.video;
            this.$root.query.report = !!this.$route.query.report;
            this.$root.query.tools = !!this.$route.query.tools;
            this.$root.query.plan = this.$route.query.plan;
        }
    }
</script>
